import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { RoleCreateRequest, RoleDTO } from './roles-admin.model';

@Injectable({ providedIn: 'root' })
export class RolesAdminService extends BaseService {
    private readonly ROLES = SICOM_PATHS.sistema.roles.base;
    private readonly USUARIOS = SICOM_PATHS.sistema.roles.usuarios;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    listarRoles(): Observable<RoleDTO[]> {
        return this.http.get<RoleDTO[]>(this.ROLES);
    }
    criarRole(req: RoleCreateRequest): Observable<void> {
        return this.http.post<void>(this.ROLES, req);
    }
    atualizarRole(name: string, description?: string): Observable<void> {
        return this.http.put<void>(`${this.ROLES}/${encodeURIComponent(name)}`, { description });
    }
    excluirRole(name: string): Observable<void> {
        return this.http.delete<void>(`${this.ROLES}/${encodeURIComponent(name)}`);
    }
    rolesDoUsuario(userId: string): Observable<RoleDTO[]> {
        return this.http.get<RoleDTO[]>(`${this.USUARIOS}/${userId}/roles`);
    }
    atribuir(userId: string, roles: string[]): Observable<void> {
        return this.http.post<void>(`${this.USUARIOS}/${userId}/roles`, { roles });
    }
    remover(userId: string, role: string): Observable<void> {
        return this.http.delete<void>(`${this.USUARIOS}/${userId}/roles/${encodeURIComponent(role)}`);
    }
    /** Remove várias roles de uma vez — uma requisição só, em vez de um DELETE por role. */
    removerVarias(userId: string, roles: string[]): Observable<void> {
        return this.http.delete<void>(`${this.USUARIOS}/${userId}/roles`, { body: { roles } });
    }
}
